<template lang="pug">
.container
  .error-body.m-auto.align-items-center.d-flex.flex-column.justify-content-center
    .image-animation.position-relative
      <svg id="bg" width="132" height="133" viewBox="0 0 132 133" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.5" cx="83.502" cy="83.8631" r="48.285" transform="rotate(15 83.502 83.8631)" fill="#7190FF"/>
        <path opacity="0.5" d="M80.986 8.24568C82.4154 2.91102 87.8988 -0.254802 93.2335 1.17462L118.444 7.92985C123.779 9.35927 126.945 14.8426 125.515 20.1773L121.209 36.2503L76.6793 24.3187L80.986 8.24568Z" fill="#7190FF"/>
        <path opacity="0.5" d="M7.66609 88.2182C2.33143 86.7888 -0.834392 81.3054 0.595026 75.9707L7.35026 50.7599C8.77968 45.4252 14.263 42.2594 19.5977 43.6888L35.6707 47.9956L23.7391 92.5249L7.66609 88.2182Z" fill="#7190FF"/>
      </svg>


      #clock
        svg(width="136" height="135" viewBox="0 0 136 135" fill="none" xmlns="http://www.w3.org/2000/svg")
          circle(opacity="0.5" cx="84.0347" cy="83.2767" r="48.285" transform="rotate(-30 84.0347 83.2767)" stroke="#0A3BE7" stroke-width="6")
          path(opacity="0.5" d="M8.77067 84.3816C5.03641 83.381 2.82034 79.5426 3.82093 75.8084L10.5762 50.5975C11.5768 46.8632 15.4151 44.6471 19.1494 45.6477L32.3246 49.178L21.9459 87.9119L8.77067 84.3816Z" stroke="#0A3BE7" stroke-width="6")
          path(opacity="0.5" d="M123.151 18.8144C124.151 15.0802 121.935 11.2418 118.201 10.2412L92.9901 3.48599C89.2559 2.4854 85.4175 4.70148 84.4169 8.43574L80.8866 21.611L119.62 31.9897L123.151 18.8144Z" stroke="#0A3BE7" stroke-width="6")
          path(opacity="0.5" d="M89.801 79.9468C91.6401 83.1323 90.5487 87.2055 87.3633 89.0446C84.1778 90.8837 80.1047 89.7923 78.2655 86.6068C76.4264 83.4214 77.5178 79.3482 80.7033 77.5091C83.8887 75.67 87.9619 76.7614 89.801 79.9468Z" fill="#0A3BE7")
          path(opacity="0.5" d="M48.866 25.0663L40.541 10.647" stroke="#0A3BE7" stroke-width="6")
          path(opacity="0.5" d="M60.8425 9.18003L58.9053 22.4748" stroke="#0A3BE7" stroke-width="6")
          path(opacity="0.5" d="M29.6009 27.2172L42.083 32.1869" stroke="#0A3BE7" stroke-width="6")

        .clockwise
          #hour
            svg(width="25" height="37" viewBox="0 0 25 37" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(fill-rule="evenodd" clip-rule="evenodd" d="M5.41013 0.702304L24.5576 33.8668L19.4952 36.7896L0.347656 3.62512L5.41013 0.702304Z" fill="#5C7DEF")

          #minute
            svg(width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg")
              rect(x="0.273438" y="3.79602" width="5.87892" height="24.7338" transform="rotate(-30 0.273438 3.79602)" fill="#5C7DEF")

    p.text-mono4.error-text.text-center.mb-2 {{ $t("staticSite.maintain.title") }}
    p.typo-paragraph14.typo-regular-150.text-center(v-html="$t('staticSite.maintain.desc')")
    .btn-group.error-btn.mt-5
      button.btn.btn-default.btn-outline(@click="$chatbox.show")
        svg(class="mr-half" width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg")
          g
            circle(cx="4" cy="4.5" r="4" fill="#3C67FF")
        | {{ $t("generals.liveC" )}}
</template>

<script>
export default {
  name: "Maintain"
};
</script>

<style lang="scss" scoped>
.error-body {
  min-width: 600px;
  // min-height: 378px;
  max-width: 600px;
  // max-height: 378px;
  height: calc(100vh - 65px);

  .image-animation {
    min-width: 168px;
    min-height: 168px;

    #bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    #clock {
      position: absolute;
      top: 47%;
      left: 51%;
      transform: translate(-50%, -50%);

      .clockwise {
        position: absolute;
        top: 32%;
        left: 40%;

        #hour {
          position: absolute;
          top: 38px;
          left: 29.5px;
          animation: clockwiseSpin 2s infinite linear;

          svg {
            position: absolute;
          }
        }

        #minute {
          position: absolute;
          top: 38px;
          left: 31px;

          animation: clockwiseSpin 6s infinite linear;

          svg {
            position: absolute;
            top: -26px;
            left: -18px;
          }
        }
      }

      animation-name: clock;
      animation-duration: 2s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;

      // transition: all 0.3s ease;
    }
  }

  .error-text {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
  }

  .error-btn {
    button {
      min-width: 180px;
    }
  }
}

@keyframes clock {
  50% {
    top: 40%;
  }
}

@keyframes antiClockwiseSpin {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@keyframes antiClockwiseSpin {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@-webkit-keyframes clockwiseSpin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes clockwiseSpin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
